<template>
    <div>
        <div>
            <img class="top_banner" src="@/assets/img/qr/bgres.jpg" />
        </div>
        <div class="sec1">
            <div class="content">
                <div>
                    <span class="smtitle" style="letter-spacing: 6.9px"
                        >时间戳签发机构</span
                    ><font class="smcolor">:</font>
                    <p class="smcont">联合信任时间戳服务中心</p>
                </div>
                <div>
                    <span class="smtitle" style="letter-spacing: 2.2px"
                        >时间戳公钥证书标识</span
                    ><font class="smcolor">:</font>
                    <p class="smcont">China TSA China Time-Stamp Authority</p>
                </div>
                <div>
                    <span class="smtitle" style="letter-spacing: 2.2px"
                        >证书编号</span
                    ><font class="smcolor">:</font>
                    <p class="smcont">{{info.certSn}}</p>
                </div>
                <div style="clear:both"></div>
            </div>
        </div>
        <div class="sec2">
            <div class="row1 row">
                <div class="fl mrt_f5">
                    <div class="rect"></div>
                    <div class="circle"></div>
                    <div class="rect rect21"></div>
                </div>
                <div class="fl mrl_b2">
                    <div>申请人:</div>
                    <div>
                        <div
                            id="d1"
                            class="ui_input"
                        >{{info.applyName}}</div>
                    </div>
                </div>
                <div class="clboth"></div>
            </div>
            <div class="row2 row">
                <div class="fl mrt_f5">
                    <div class="rect"></div>
                    <div class="circle"></div>
                    <div class="rect rect22"></div>
                </div>
                <div class="fl mrl_b2">
                    <div>文件名称:</div>
                    <div>
                        <div
                            id="d2"
                            class="ui_input"
                        > {{info.opusName}} </div>
                    </div>
                </div>
                <div class="clboth"></div>
            </div>
            <div class="row3 row">
                <div class="fl mrt_f5">
                    <div class="rect"></div>
                    <div class="circle"></div>
                    <div class="rect rect23"></div>
                </div>
                <div class="fl mrl_b2">
                    <div>申请时间:</div>
                    <div>
                        <div
                            id="d3"
                            class="ui_input"
                        >{{info.opDate}}</div>
                    </div>
                </div>
                <div class="clboth"></div>
            </div>
            <div class="row4 row">
                <div class="fl mrt_f5">
                    <div class="rect"></div>
                    <div class="circle"></div>
                    <div class="rect rect24"></div>
                </div>
                <div class="fl mrl_b2">
                    <div>时间戳认证码:</div>
                    <div>
                        <div
                            id="d4"
                            class="ui_input"
                        >{{info.hash}}</div>
                    </div>
                </div>
                <div class="clboth"></div>
            </div>
            <div class="row5 row">
                <div class="fl mrt_f5">
                    <div class="rect"></div>
                    <div class="circle"></div>
                    <div class="rect"></div>
                    <div class="rect rect25"></div>
                </div>
                <div class="fl mrl_b2">
                    <div>申请人自述说明:</div>
                    <div
                        id="d5"
                        class="ui_input"
                    >{{info.opusDescribe}}</div>
                </div>
                <div class="clboth"></div>
            </div>
        </div>
        <div class="sec3">
            更多服务及其他相关信息请前往 <a href="https://m.tsa.cn/">WWW.TSA.CN</a> 注册登录使用
        </div>
    </div>
</template>

<script>
import {findQr} from '@/api/service'
export default {
    data() {
        return {
            info:{},
        };
    },

    components: {},

    computed: {},

    async created() {
        try {
            let res=await findQr(this.$route.query);
            this.info=res;
        }catch (err){
            this.$toast(err.data.message)
        }
        
    },

    mounted() {

    },

    methods: {},
};
</script>
<style lang="less" scoped>
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
    padding-bottom: 45px;
}
body {
    background: #f5f5f5;
    font-size: 16px;
}
.fl {
    float: left;
    .circle{
        position: absolute;
        z-index: 999;
        left: -1Px;
        background: #f0f0f0;
    }
}
.clboth {
    clear: both;
}
.top_banner {
    width: 100%;
    display: block;
}
.sec1 {
    width: 96%;
    margin:0 auto;
    position: relative;
}
.content {
    margin-top:-30px;
    background: #ffffff;
    width: 100%;
    border-radius: 5px;
    padding: 8px 0;
}
.content2 {
    z-index: 1;
    -webkit-transform: scale(0.9);
    transform: scale(0.95);
    top: -10px;
}
.sec1 .content .smcont {
    word-break: break-all;
    margin: 8px 0;
    margin-left: 170px;
    padding-right: 5px;
}

.smtitle {
    color: rgb(74, 159, 239);
    width: 155px;
    display: inline-block;
    float: left;
}
.smcolor {
    color: rgb(74, 159, 239);
    display: inline-block;
    float: left;
}
.sec1 .content div {
    font-size: 14px;
    color: #7d7d7d;
}

.sec1 .content span {
    margin-left: 2%;
}
.sec2 {
    width: 96%;
    margin: 12px auto 0;
    color: #4d4d4d;
    font-size: 14px;
    padding-bottom:42px;
}
.sec2 .row{
    position: relative;
    &::after{
        content:'';
        display: block;
        width: 1Px;
        height: 100%;
        top:0;
        left:3Px;
        position: absolute;
        background:#26a2ff;
    }
}
.rect {
    width: 1px;
    height: 10px;
    background-color: none;
    margin-left: 3px;
}

.circle {
    border-radius: 50%;
    width: 7Px;
    height: 7Px;
    border: 1Px solid #26a2ff;
}
.mrt_f5 {
    margin-top: -5px;
}
.mrl_b2 {
    margin-left: 2%;
    width: 90%;
    margin-bottom: 10px;
}
.ui_input {
    word-wrap: break-word;
    word-break: break-all;
    width: 100%;
    min-height: 28px;
    line-height: 28px;
    background-color: #fff;
    border-radius: 2px;
    padding: 0 6px;
    color: #7d7d7d;
    margin-top: 7px;
    box-shadow: 0 0 2px 2px rgba(229, 229, 229, 0.3);
    border-radius: 4px;
    border: 0;
}
.sec3 {
    width: 100%;
    text-align: center;
    background-color: #ffffff;
    color: #7d7d7d;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    position: fixed;
    bottom: 0;
    left: 0;
}

@media screen and (max-width: 358px) {
    .sec3 {
        height: 80px;
    }
}
.sec3 a {
    color: #26a2ff;
}
</style>
